export default __webpack_public_path__ + "static/media/16.8aa62666.png";